import { useState } from 'react'

import ProductsList from './ProductsList'
import WaitListInfo from './WaitListInfo'

const ProductSelection = ({ value, startDate, onNext, waitingListIdProduct, isWaitListFlow }) => {
    const [itemAddingToWaitList, setItemAddingToWaitList] = useState(null)

    return itemAddingToWaitList ? (
        <WaitListInfo item={itemAddingToWaitList} goToProducts={() => setItemAddingToWaitList(null)} />
    ) : (
        <ProductsList
            onNext={onNext}
            startDate={startDate}
            value={value}
            setItemAddingToWaitList={setItemAddingToWaitList}
            waitingListIdProduct={waitingListIdProduct}
            isWaitListFlow={isWaitListFlow}
        />
    )
}

export default ProductSelection
